import { render, staticRenderFns } from "./JobInvoices.vue?vue&type=template&id=b2c95fe6&"
import script from "./JobInvoices.vue?vue&type=script&lang=js&"
export * from "./JobInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports